import { lazy, Suspense } from "react";
import { usePageActions } from "./contexts/PermissionContext";
import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import { Home } from "./components/Home";
import { Login } from "./components/Login";
import { ForgotPasswordPage } from "./components/ForgotPasswordPage";
import { ResetPasswordPage } from "./components/ResetPasswordPage";
import { ForcePasswordChangePage } from "./components/ForcePasswordChangePage";
import { OidcCallback } from "./components/OidcCallback";
import { Dashboard } from "./components/Dashboard";
import { RulesPage } from "./components/RulesPage";
import { RulesPageLegacy } from "./components/RulesPage.legacy";
import { RuleCategoryPage } from "./components/RuleCategoryPage";
import { RuleCategoryPageLegacy } from "./components/RuleCategoryPage.legacy";
import { WorkflowManagementPage } from "./components/WorkflowManagementGridPage";
import { WorkflowManagementPageLegacy } from "./components/WorkflowManagementGridPage.legacy";
import { RolePage } from "./components/RolePage";
import { RolePageLegacy } from "./components/RolePage.legacy";
import { UserPage } from "./components/UserPage";
import { UserPageLegacy } from "./components/UserPage.legacy";
import { TenantsPage } from "./components/TenantsPage";
import { TenantDetailPage } from "./components/TenantDetailPage";
import { TenantUsagePage } from "./components/TenantUsagePage";
import { LicensesPage } from "./components/LicensesPage";
import { LicenseDetailPage } from "./components/LicenseDetailPage";
import { ActionListPage } from "./components/ActionListPage";
import { ActionListPageLegacy } from "./components/ActionListPage.legacy";
import { EmbedDemoPage } from "./components/EmbedDemoPage";
import SyncPage from "./components/SyncPage";
import { TelemetryPage } from "./components/TelemetryPage";
import { TelemetryPageLegacy } from "./components/TelemetryPage.legacy";
import { SoapServicesPage } from "./components/SoapServicesPage";
import { SoapServiceDetailPage } from "./components/SoapServiceDetailPage";
import { EtlPipelinePage } from "./components/EtlPipelinePage";
import { EtlPipelinePageLegacy } from "./components/EtlPipelinePage.legacy";
import { AnnouncementsPage } from "./components/AnnouncementsPage";
import { AnnouncementsPageLegacy } from "./components/AnnouncementsPage.legacy";
import { CreditCardCollectionPage } from "./components/PaymentPage";
import { DbsDefinitionsPage } from "./components/DbsDefinitionsPage";
import { DbsDefinitionsPageLegacy } from "./components/DbsDefinitionsPage.legacy";
import { FinanceTransactionsPage } from "./components/FinanceTransactionsPage";
import { FinanceTransactionDetailPage } from "./components/FinanceTransactionDetailPage";
// Finans tür kayıt defteri — rotalar buradan üretilir (bkz. aşağıdaki finans bloğu).
import { TYPES as FINANCE_TYPES, listRouteOf as financeListRoute } from "./components/finance/financeTypeMeta";
// #Faz2 Tahsilat–Fatura Eşleştirme (menü 9737 / 9750)
import { UnallocatedCollectionsPage } from "./components/UnallocatedCollectionsPage";
import { AgingReportPage } from "./components/AgingReportPage";
import { PaymentTrackingPage } from "./components/PaymentTrackingPage";
import { PaymentTrackingPageLegacy } from "./components/PaymentTrackingPage.legacy";
import { PaymentTypesPage } from "./components/PaymentTypesPage";
import { ProductGroupsPage } from "./components/ProductGroupsPage";
import { ProductSubGroupsPage } from "./components/ProductSubGroupsPage";
import { ProductDynamicGroupsPage } from "./components/ProductDynamicGroupsPage";
import { ProductDynamicGroupsPageLegacy } from "./components/ProductDynamicGroupsPage.legacy";
import { ProductRestrictionsPage } from "./components/ProductRestrictionsPage";
import { ProductRestrictionsPageLegacy } from "./components/ProductRestrictionsPage.legacy";
import { ProductRoutingPage } from "./components/ProductRoutingPage";
import { CriticalSkuPage } from "./components/CriticalSkuPage";
import { CriticalSkuDetailPage } from "./components/CriticalSkuDetailPage";
import { PricesPage } from "./components/PricesPage";
import { ProductAdditionalFieldsPage } from "./components/ProductAdditionalFieldsPage";
import { ProductAdditionalFieldsPageLegacy } from "./components/ProductAdditionalFieldsPage.legacy";
import { ProductsPage } from "./components/ProductsPage";
import { ProductDetailV2Page } from "./components/ProductDetailV2Page";
import { GeneralParametersPage } from "./components/GeneralParametersPage";
// KULLANICI_YETKI_YONETIMI Faz 1 — Güvenlik & İzleme grubu (menü 9615-9618).
import { LoginAuditPage } from "./components/LoginAuditPage";
import { SessionsPage } from "./components/SessionsPage";
import { DevicesPage } from "./components/DevicesPage";
import { AuditLogPage } from "./components/AuditLogPage";
// Faz 2 — G-Y-10 etkin yetki görüntüleyici (menü 9614). KK-01 gereği zorunlu.
import { EffectivePermissionsPage } from "./components/EffectivePermissionsPage";
import { PermissionTemplatesPage } from "./components/PermissionTemplatesPage";
import { FieldRightsPage } from "./components/FieldRightsPage";
import { UserGroupsPage } from "./components/UserGroupsPage";
import { ProductsPageLegacy } from "./components/ProductsPage.legacy";
import { ProducersPage } from "./components/ProducersPage";
import { PersonnelPage } from "./components/PersonnelPage";
import { PersonnelDetailPage } from "./components/PersonnelDetailPage";
// Popup→DetailPage migrasyonu (Dalga 1)
import { RepresentativeTypeDetailPage } from "./components/RepresentativeTypeDetailPage";
import { RuleCategoryDetailPage } from "./components/RuleCategoryDetailPage";
import { CustomerAdditionalFieldDetailPage } from "./components/CustomerAdditionalFieldDetailPage";
import { ProductAdditionalFieldDetailPage } from "./components/ProductAdditionalFieldDetailPage";
import { AnnouncementDetailPage } from "./components/AnnouncementDetailPage";
import { DocumentSeriesDetailPage } from "./components/DocumentSeriesDetailPage";
import { WarehouseDetailPage } from "./components/WarehouseDetailPage";
import { CoolerDetailPage } from "./components/CoolerDetailPage";
// Popup→DetailPage migrasyonu (Dalga 2)
import { RoleDetailPage } from "./components/RoleDetailPage";
import { MobilePermissionsPage } from "./components/MobilePermissionsPage";
import { MobilePermissionDetailPage } from "./components/MobilePermissionDetailPage";
import { UserDetailPage } from "./components/UserDetailPage";
import { CustomerNoteDetailPage } from "./components/CustomerNoteDetailPage";
import { CustomerTaskDetailPage } from "./components/CustomerTaskDetailPage";
import { CoolerFaultDetailPage } from "./components/CoolerFaultDetailPage";
import { TrainingDetailPage } from "./components/TrainingDetailPage";
import { DbsDefinitionDetailPage } from "./components/DbsDefinitionDetailPage";
import { ShipmentVehicleDetailPage } from "./components/ShipmentVehicleDetailPage";
import { DistributorsPage } from "./components/DistributorsPage";
import { DistributorDetailPage } from "./components/DistributorDetailPage";
// Popup→DetailPage migrasyonu (Dalga 3)
import { VendorDetailPage } from "./components/VendorDetailPage";
import { RepresentativeDetailPage } from "./components/RepresentativeDetailPage";
import { PriceDetailPage } from "./components/PriceDetailPage";
import { RuleDetailPage } from "./components/RuleDetailPage";
import { SurveyDetailPage } from "./components/SurveyDetailPage";
import { AgreementDetailPage } from "./components/AgreementDetailPage";
import { ProductRestrictionDetailPage } from "./components/ProductRestrictionDetailPage";
import { CustomerDynamicGroupDetailPage } from "./components/CustomerDynamicGroupDetailPage";
// Popup→DetailPage migrasyonu (Dalga 4)
import { ProductDynamicGroupDetailPage } from "./components/ProductDynamicGroupDetailPage";
import { DeliveryNoteDetailPage } from "./components/DeliveryNoteDetailPage";
import { VehicleLoadDetailPage } from "./components/VehicleLoadDetailPage";
import { EtlPipelineDetailPage } from "./components/EtlPipelineDetailPage";
import { PaymentDetailPage } from "./components/PaymentDetailPage";
// Popup→DetailPage migrasyonu (Özel: NamedDefinition kümesi, Customers, BelgeDizayni)
import { NamedDefinitionDetailPage } from "./components/NamedDefinitionDetailPage";
import { NonSaleReasonsPage } from "./components/NonSaleReasonsPage";
import { BelgeDizayniCreatePage } from "./components/BelgeDizayniCreatePage";
// Popup→DetailPage migrasyonu (Final: Workflow canlı ekranı + Risk gömülü ekranları)
import { WorkflowDetailPage } from "./components/WorkflowDetailPage";
import { RiskCategoryDetailPage } from "./components/RiskCategoryDetailPage";
import { RiskMasterDetailPage } from "./components/RiskMasterDetailPage";
import { SalesOrgHierarchyPage } from "./components/SalesOrgHierarchyPage";
import { CustomersPage } from "./components/CustomersPage";
import { CustomerDetailPage } from "./components/CustomerDetailPage";
import { CustomerEditPage } from "./components/CustomerEditPage";
import { CustomerAdditionalFieldsPage } from "./components/CustomerAdditionalFieldsPage";
import { CustomerAdditionalFieldsPageLegacy } from "./components/CustomerAdditionalFieldsPage.legacy";
import { CustomerDynamicGroupsPage } from "./components/CustomerDynamicGroupsPage";
import { CustomerDynamicGroupsPageLegacy } from "./components/CustomerDynamicGroupsPage.legacy";
import { VendorsPage } from "./components/VendorsPage";
import { VendorsPageLegacy } from "./components/VendorsPage.legacy";
import { WarehousesPage } from "./components/WarehousesPage";
import { WarehousesPageLegacy } from "./components/WarehousesPage.legacy";
import { ShipmentVehiclesPage } from "./components/ShipmentVehiclesPage";
import { StockPage } from "./components/StockPage";
import { StockPageLegacy } from "./components/StockPage.legacy";
import { StockDocumentsListPage } from "./components/StockDocumentsListPage";
// Faz 3 — Araçlar arası transfer izleme (menü 9537) + TRANSIT fark çözümleme (menü 9538).
// Depo→depo StockDocument transferinden (/stock-transfer) AYRI ekranlardır.
import { StockTransfersPage } from "./components/StockTransfersPage";
import { StockTransferDetailPage } from "./components/StockTransferDetailPage";
// Faz 4 — Satıcıya İade (menü 9545), GİB İzleme (9546), Kalan İade Edilebilir Miktar (9547).
// Muhasebenin elle kestiği iade faturası ekranı (/return-invoices) KORUNUR — bunlar SAHA belgesidir.
import { VendorReturnsPage } from "./components/VendorReturnsPage";
import { VendorReturnCreatePage } from "./components/VendorReturnCreatePage";
import { VendorReturnDetailPage } from "./components/VendorReturnDetailPage";
import { GibMonitorPage } from "./components/GibMonitorPage";
import { EDocumentControlPage } from "./components/eDocument/EDocumentControlPage";
// Faz 5 — Depozito İade İrsaliyesi (menü 9548) + Depozito Mutabakatı (9549).
// DepositCountsPage (/deposit-counts) SAYIM ekranıdır ve AYRI KALIR: o "araçta kaç sepet var"
// der ve stoğa dokunmaz; bunlar İADE belgesini yönetir ve depozito stoğunu düşürür.
import { DepositReturnsPage } from "./components/DepositReturnsPage";
import { DepositReturnDetailPage } from "./components/DepositReturnDetailPage";
import { DepositReconciliationPage } from "./components/DepositReconciliationPage";
// Menü 9551 — Nama Sevk Belgeleri (Belge Merkezi). Satıcı HER ZAMAN Sütaş'tır; belge SAP/telsel'de
// doğar ve orada faturalaşır → bizim Fatura/Sipariş hattımıza KARIŞTIRILMAZ, kendi hattındadır.
import { NamaDocumentsPage } from "./components/NamaDocumentsPage";
import { NamaDocumentCreatePage } from "./components/NamaDocumentCreatePage";
import { NamaDocumentDetailPage } from "./components/NamaDocumentDetailPage";
import { ReturnableQuantitiesReportPage } from "./components/ReturnableQuantitiesReportPage";
import { WarehouseStockResetListPage } from "./components/WarehouseStockResetListPage";
import { WarehouseStockResetDetailPage } from "./components/WarehouseStockResetDetailPage";
import { ProductSegmentationTreeListPage } from "./components/ProductSegmentationTreeListPage";
import { ProductSegmentationTreePage } from "./components/ProductSegmentationTreePage";
import { RepresentativeTypesPage } from "./components/RepresentativeTypesPage";
import { RepresentativeTypesPageLegacy } from "./components/RepresentativeTypesPage.legacy";
import { SalesManagersPage } from "./components/SalesManagersPage";
import { RepresentativesPage } from "./components/RepresentativesPage";
import { RepresentativesPageLegacy } from "./components/RepresentativesPage.legacy";
import { RepresentativeGroupsPage } from "./components/RepresentativeGroupsPage";
import { OrderHeadersPage } from "./components/OrderHeadersPage";
import { OrderDetailPage } from "./components/OrderDetailPage";
import { OrderHeadersPageLegacy } from "./components/OrderHeadersPage.legacy";
import { InvoicesPage } from "./components/InvoicesPage";
import { InvoiceDetailV2Page } from "./components/InvoiceDetailV2Page";
import { InvoicesPageLegacy } from "./components/InvoicesPage.legacy";
import { WaybillsPage } from "./components/WaybillsPage";
import { WaybillDetailPage } from "./components/WaybillDetailPage";
import { BelgeDizayniPage } from "./components/BelgeDizayniPage";
import { BelgeDizayniDesignerPage } from "./components/BelgeDizayniDesignerPage";
import { DocumentSeriesPage } from "./components/DocumentSeriesPage";
import { LinkRiskTrackingPage } from "./components/LinkRiskTrackingPage";
import { AccountStatementPage } from "./components/AccountStatementPage";
import { AssistantChatPage } from "./components/AssistantChatPage";
import { ApprovalRequestsPage } from "./components/ApprovalRequestsPage";
import { ApprovalRequestsPageLegacy } from "./components/ApprovalRequestsPage.legacy";
import { B2bReturnsPage } from "./components/B2bReturnsPage";
import { B2bReturnsPageLegacy } from "./components/B2bReturnsPage.legacy";
import { VisitsPage } from "./components/VisitsPage";
import { VisitsPageLegacy } from "./components/VisitsPage.legacy";
import { VehicleLoadsPage } from "./components/VehicleLoadsPage";
import { VehicleLoadsPageLegacy } from "./components/VehicleLoadsPage.legacy";
import { VehicleCountsPage } from "./components/VehicleCountsPage";
import { VehicleCountsPageLegacy } from "./components/VehicleCountsPage.legacy";
import { DeliveryNotesPage } from "./components/DeliveryNotesPage";
import { DeliveryNotesPageLegacy } from "./components/DeliveryNotesPage.legacy";
import { TrainingsPage } from "./components/TrainingsPage";
import { TrainingsPageLegacy } from "./components/TrainingsPage.legacy";
import { CampaignsPage } from "./components/CampaignsPage";
import { CampaignsPageLegacy } from "./components/CampaignsPage.legacy";
import { CampaignDetailPage } from "./components/CampaignDetailPage";
import { CampaignAuthorizationsPage } from "./components/CampaignAuthorizationsPage";
import { CampaignAuthorizationsPageLegacy } from "./components/CampaignAuthorizationsPage.legacy";
import { CampaignAuthorizationDetailPage } from "./components/CampaignAuthorizationDetailPage";
import { ScheduledTasksPage } from "./components/ScheduledTasksPage";
import { ScheduledTaskDetailPage } from "./components/ScheduledTaskDetailPage";
import { DocumentDerivationsPage } from "./components/DocumentDerivationsPage";
import { DocumentDerivationDetailPage } from "./components/DocumentDerivationDetailPage";
import { TargetsPage } from "./components/TargetsPage";
import { TargetWizardPage } from "./components/TargetWizardPage";
import { LeaderboardPage } from "./components/LeaderboardPage";
import { GamificationBadgesPage } from "./components/GamificationBadgesPage";
import { AgreementsPage } from "./components/AgreementsPage";
import { AgreementsPageLegacy } from "./components/AgreementsPage.legacy";
import { SurveysPage } from "./components/SurveysPage";
import { SurveysPageLegacy } from "./components/SurveysPage.legacy";
import { CoolersPage } from "./components/CoolersPage";
import { CoolersPageLegacy } from "./components/CoolersPage.legacy";
import { CoolerFaultsPage } from "./components/CoolerFaultsPage";
import { CoolerFaultsPageLegacy } from "./components/CoolerFaultsPage.legacy";
import { CustomerTasksPage } from "./components/CustomerTasksPage";
import { CustomerTasksPageLegacy } from "./components/CustomerTasksPage.legacy";
import { CustomerNotesPage } from "./components/CustomerNotesPage";
import { CustomerNotesPageLegacy } from "./components/CustomerNotesPage.legacy";
import { DepositCountsPage } from "./components/DepositCountsPage";
import { DepositCountsPageLegacy } from "./components/DepositCountsPage.legacy";
import { RoutePlansPage } from "./components/RoutePlansPage";
import { RoutePlanDetailPage } from "./components/RoutePlanDetailPage";
import { ShipmentPlanningListPage } from "./components/ShipmentPlanningListPage";
import { ShipmentPlanningBoardPage } from "./components/ShipmentPlanningBoardPage";
import { CustomerMembershipsPage } from "./components/CustomerMembershipsPage";
import { CustomerMembershipsPageLegacy } from "./components/CustomerMembershipsPage.legacy";
import { StandCountsPage } from "./components/StandCountsPage";
import { StandCountsPageLegacy } from "./components/StandCountsPage.legacy";
// Demirbaş Takibi (Assets)
import { AssetsPage } from "./components/AssetsPage";
import { AssetDetailPage } from "./components/AssetDetailPage";
import { AssetCountsPage } from "./components/AssetCountsPage";
import { AssetCountOrdersPage } from "./components/AssetCountOrdersPage";
import { AssetCountOrderDetailPage } from "./components/AssetCountOrderDetailPage";
import { AssetModelsPage } from "./components/AssetModelsPage";
import { AssetModelDetailPage } from "./components/AssetModelDetailPage";
import { AssetAttributeDefsPage } from "./components/AssetAttributeDefsPage";
import { AssetAttributeDefDetailPage } from "./components/AssetAttributeDefDetailPage";
import { AssetDraftsPage } from "./components/AssetDraftsPage";
import { AssetImportPage } from "./components/AssetImportPage";
import { ReportsPage } from "./components/ReportsPage";
import { SalesDetailReportPage, CollectionDetailReportPage } from "./components/DetailReports";
import { CustomerReportCriteriaPage, CustomerReportListPage } from "./components/CustomerReportPage";
import { VisitAnalysisCriteriaPage, VisitAnalysisListPage } from "./components/VisitAnalysisReportPage";
import { RouteDefinitionCriteriaPage, RouteDefinitionListPage } from "./components/RouteDefinitionReportPage";
import { RoutePlanDetailCriteriaPage, RoutePlanDetailListPage } from "./components/RoutePlanDetailReportPage";
import { AssetStatusCriteriaPage, AssetStatusListPage } from "./components/AssetStatusReportPage";
import { StockLedgerCriteriaPage, StockLedgerListPage } from "./components/StockLedgerReportPage";
import { VisitDetailCriteriaPage, VisitDetailListPage } from "./components/VisitDetailReportPage";
import { CurrentStockCriteriaPage, CurrentStockListPage } from "./components/CurrentStockReportPage";
import { ProductListCriteriaPage, ProductListListPage } from "./components/ProductListReportPage";
import { DistChannelListCriteriaPage, DistChannelListListPage } from "./components/DistChannelListReportPage";
import { VehicleListCriteriaPage, VehicleListListPage } from "./components/VehicleListReportPage";
import { DistributorListCriteriaPage, DistributorListListPage } from "./components/DistributorListReportPage";
import { WarehouseListCriteriaPage, WarehouseListListPage } from "./components/WarehouseListReportPage";
import { RepresentativeListCriteriaPage, RepresentativeListListPage } from "./components/RepresentativeListReportPage";
import { PriceListCriteriaPage, PriceListListPage } from "./components/PriceListReportPage";
import { CampaignListCriteriaPage, CampaignListListPage } from "./components/CampaignListReportPage";
import { OrderListCriteriaPage, OrderListListPage } from "./components/OrderListReportPage";
import { WaybillListCriteriaPage, WaybillListListPage } from "./components/WaybillListReportPage";
import { InvoiceListCriteriaPage, InvoiceListListPage } from "./components/InvoiceListReportPage";
import { StockDocumentCriteriaPage, StockDocumentListPage } from "./components/StockDocumentReportPage";
import { FinanceCriteriaPage, FinanceListPage } from "./components/FinanceReportPage";
import { StockLedgerSummaryCriteriaPage, StockLedgerSummaryListPage } from "./components/StockLedgerSummaryReportPage";
import { CustomerStatementSummaryCriteriaPage, CustomerStatementSummaryListPage } from "./components/CustomerStatementSummaryReportPage";
import { CustomerStatementDetailCriteriaPage, CustomerStatementDetailListPage } from "./components/CustomerStatementDetailReportPage";
import { CustomerProductCriteriaPage, CustomerProductListPage } from "./components/CustomerProductReportPage";
import { FieldVisitsPage } from "./components/FieldVisitsPage";
import { FieldVisitDetailPage } from "./components/FieldVisitDetailPage";
// Ziyaret Takip — üç katmanlı saha izleme (gün / ziyaret / hareket). Mevcut
// "Saha Ziyaretleri" (9118) oturum listesi olarak KALIR; bu ekran onun üstüne
// katman kırılımını, kural motorunu ve canlı hareket akışını ekler.
import { VisitTrackingPage } from "./components/VisitTrackingPage";
import { VisitActivityTypesPage } from "./components/VisitActivityTypesPage";
import { VisitActivityTypeDetailPage } from "./components/VisitActivityTypeDetailPage";
// #44 Ekip mesajlaşması back office ekranları
import { TeamChatBannedWordsPage } from "./components/TeamChatBannedWordsPage";
import { TeamChatBannedWordDetailPage } from "./components/TeamChatBannedWordDetailPage";
import { TeamChatArchivePage } from "./components/TeamChatArchivePage";
import { TeamChatArchiveDetailPage } from "./components/TeamChatArchiveDetailPage";
// #45 Destek Talepleri (menü 9620, Sistem Yönetimi) — mobil/web kullanıcısının destek
// sohbetinden doğan talepler; yazışmayı destek personeli bu ekrandan sürdürür.
import { SupportTicketsPage } from "./components/SupportTicketsPage";
import { SupportTicketDetailPage } from "./components/SupportTicketDetailPage";
import { ChiefDashboardPage } from "./components/ChiefDashboardPage";
import { NotificationsPage } from "./components/NotificationsPage";
import { NotificationsPageLegacy } from "./components/NotificationsPage.legacy";
import { SalesAnalyticsPage } from "./components/SalesAnalyticsPage";

// Dashboards (Rona AI) — menü grubu 9870, migration 20260713170000_AddDashboardsMenuGroup.
// Hepsi ayrı chunk olarak lazy yüklenir: ana bundle'ı büyütmezler, girilmedikçe inmezler.
const DashboardV2 = lazy(() => import("./components/DashboardV2"));
const CustomerDashboard = lazy(() => import("./components/dashboardV2/CustomerDashboard"));
const ProductDashboard = lazy(() => import("./components/dashboardV2/ProductDashboard"));
const FinanceDashboard = lazy(() => import("./components/dashboardV2/FinanceDashboard"));
const FieldDashboard = lazy(() => import("./components/dashboardV2/FieldDashboard"));

// Lazy sayfaları Suspense ile sarar (fallback: boş — iskelet zaten kendi yükleme durumunu gösterir).
const lazyPage = (element) => <Suspense fallback={null}>{element}</Suspense>;

// #287/#900 Faz 4 — URL ile doğrudan erişim koruması (route guard).
// Bir sayfa menüde KISITLI olup "İzle" (View) hakkı verilmemişse, o path'e URL ile
// gidildiğinde içeriği göstermeyip 403 ekranı basar. Kısıt tanımlanmamış (default-open),
// menüsü çözülemeyen (public/login sayfaları) ve haklar henüz yüklenmemiş durumlarda
// usePageActions().canView=true döner → mevcut davranış korunur, yükleme anında flash olmaz.
function RequireView({ children }) {
  const { canView } = usePageActions();
  if (canView) return children;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', padding: 24, textAlign: 'center' }}>
      <div style={{ fontSize: 44, fontWeight: 800, lineHeight: 1, color: 'var(--dps-ink-3, #94a3b8)' }}>403</div>
      <h2 style={{ margin: '14px 0 6px', fontSize: 20, fontWeight: 800, color: 'var(--dps-ink, #0b2540)' }}>Yetkiniz yok</h2>
      <p style={{ margin: 0, maxWidth: 420, color: 'var(--dps-ink-2, #48586a)', fontSize: 14 }}>
        Bu ekranı görüntüleme yetkiniz bulunmuyor. Erişim için yöneticinizle iletişime geçin.
      </p>
    </div>
  );
}

// URL ile erişimde görüntüleme hakkını doğrulamak için her route elementini RequireView ile sar.
const withGuard = (routes) => routes.map((r) => (
  r.element ? { ...r, element: <RequireView>{r.element}</RequireView> } : r
));

const AppRoutes = [
  { index: true, element: <Login /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/change-password', element: <ForcePasswordChangePage /> },
  { path: '/signin-oidc', element: <OidcCallback /> },
  { path: '/dashboard', element: <Dashboard /> },

  // Dashboards grubu (menü 9870). /dashboardv2 eski URL olarak korunur (Genel'e eş).
  { path: '/dashboardv2', element: lazyPage(<DashboardV2 />) },
  { path: '/dashboards/general', element: lazyPage(<DashboardV2 />) },
  { path: '/dashboards/customer', element: lazyPage(<CustomerDashboard />) },
  { path: '/dashboards/product', element: lazyPage(<ProductDashboard />) },
  { path: '/dashboards/finance', element: lazyPage(<FinanceDashboard />) },
  { path: '/dashboards/field', element: lazyPage(<FieldDashboard />) },

  { path: '/assistant', element: <AssistantChatPage /> },
  { path: '/actions', element: <ActionListPage /> },
  { path: '/home', element: <Home /> },
  { path: '/rules', element: <RulesPage /> },
  { path: '/rulecategories', element: <RuleCategoryPage /> },
  { path: '/workflows', element: <WorkflowManagementPage /> },
  { path: '/role-management', element: <RolePage /> },
  { path: '/general-parameters', element: <GeneralParametersPage /> },
  // Güvenlik & İzleme (9827). Hepsi SALT OKUNUR liste; withGuard → RequireView menü hakkını uygular.
  { path: '/login-audit', element: <LoginAuditPage /> },
  { path: '/sessions', element: <SessionsPage /> },
  { path: '/devices', element: <DevicesPage /> },
  { path: '/audit-log', element: <AuditLogPage /> },
  { path: '/effective-permissions', element: <EffectivePermissionsPage /> },
  { path: '/permission-templates', element: <PermissionTemplatesPage /> },
  { path: '/field-rights', element: <FieldRightsPage /> },
  { path: '/user-groups', element: <UserGroupsPage /> },
  { path: '/mobile-permissions', element: <MobilePermissionsPage /> },
  { path: '/mobile-permissions/new', element: <MobilePermissionDetailPage /> },
  { path: '/mobile-permissions/:id', element: <MobilePermissionDetailPage /> },
  { path: '/user-management', element: <UserPage /> },
  { path: '/tenants', element: <TenantsPage /> },
  { path: '/tenants/new', element: <TenantDetailPage /> },
  { path: '/tenants/:id', element: <TenantDetailPage /> },
  { path: '/tenant-usage', element: <TenantUsagePage /> },
  { path: '/licenses', element: <LicensesPage /> },
  { path: '/licenses/new', element: <LicenseDetailPage /> },
  { path: '/licenses/:id', element: <LicenseDetailPage /> },
  { path: '/embed-demo', element: <EmbedDemoPage /> },
  { path: '/sync', element: <SyncPage /> },
  { path: '/telemetry', element: <TelemetryPage /> },
  { path: '/etl-pipelines', element: <EtlPipelinePage /> },
  { path: '/announcements', element: <AnnouncementsPage /> },
  { path: '/payment', element: <PaymentTrackingPage /> },
  // Finans — Alınan Tahsilatlar + Ödemelerim (TAHSILAT_ODEME.md §1).
  // Rotalar TÜR KAYIT DEFTERİNDEN üretilir (components/finance/financeTypeMeta.js): tür listesi
  // genişletilebilirdir ve yeni bir ödeme türü için orada TEK kayıt yeterlidir — liste/yeni/detay
  // rotaları buradan otomatik doğar, üçünü elle yazarken biri unutulmaz.
  ...FINANCE_TYPES.flatMap((t) => {
    const base = financeListRoute(t);
    return [
      { path: base, element: <FinanceTransactionsPage group={t.group} slug={t.slug} /> },
      { path: `${base}/new`, element: <FinanceTransactionDetailPage group={t.group} slug={t.slug} /> },
      { path: `${base}/:id`, element: <FinanceTransactionDetailPage group={t.group} slug={t.slug} /> },
    ];
  }),

  // #Faz2 Tahsilat–Fatura Eşleştirme — path'ler 20260713101000_AddFinanceAllocationMenus ile birebir.
  { path: '/finance/unallocated', element: <UnallocatedCollectionsPage /> }, // menü 9737
  { path: '/finance/aging', element: <AgingReportPage /> },                  // menü 9750

  { path: '/dbs', element: <DbsDefinitionsPage /> },
  { path: '/credit-card-collection', element: <CreditCardCollectionPage /> },
  { path: '/payment-types', element: <PaymentTypesPage /> },
  { path: '/product-groups', element: <ProductGroupsPage /> },
  { path: '/product-sub-groups', element: <ProductSubGroupsPage /> },
  { path: '/product-dynamic-groups', element: <ProductDynamicGroupsPage /> },
  { path: '/product-dynamic-groups-legacy', element: <ProductDynamicGroupsPageLegacy /> },
  { path: '/product-restrictions', element: <ProductRestrictionsPage /> },
  { path: '/product-restrictions-legacy', element: <ProductRestrictionsPageLegacy /> },
  { path: '/product-routing', element: <ProductRoutingPage /> },
  { path: '/critical-skus', element: <CriticalSkuPage /> },
  { path: '/critical-skus/new', element: <CriticalSkuDetailPage /> },
  { path: '/critical-skus/:id', element: <CriticalSkuDetailPage /> },
  { path: '/prices', element: <PricesPage /> },
  { path: '/product-additional-fields', element: <ProductAdditionalFieldsPage /> },
  { path: '/product-additional-fields-legacy', element: <ProductAdditionalFieldsPageLegacy /> },
  { path: '/products', element: <ProductsPage /> },
  // Ürün kartı V2 tasarıma geçti; prototip menüsü (9951) ve /products-v2 rotası kaldırıldı.
  // Eski ekran `components/ProductDetailPage.js` olarak DURUYOR (import edilmiyor) — geri
  // dönmek gerekirse import edip bu iki satırı ona çevirmek yeterli.
  { path: '/products/new', element: <ProductDetailV2Page /> },
  { path: '/products/:id', element: <ProductDetailV2Page /> },
  { path: '/products-legacy', element: <ProductsPageLegacy /> },
  { path: '/product-segmentation-tree', element: <ProductSegmentationTreeListPage /> },
  { path: '/product-segmentation-tree/new', element: <ProductSegmentationTreePage /> },
  { path: '/product-segmentation-tree/:id', element: <ProductSegmentationTreePage /> },
  { path: '/producers', element: <ProducersPage /> },
  { path: '/sales-org-hierarchy', element: <SalesOrgHierarchyPage /> },
  { path: '/personnel', element: <PersonnelPage /> },
  { path: '/personnel/new', element: <PersonnelDetailPage /> },
  { path: '/personnel/:id', element: <PersonnelDetailPage /> },
  // Popup→DetailPage migrasyonu (Dalga 1) — /new, /:id'den ÖNCE
  { path: '/representative-types/new', element: <RepresentativeTypeDetailPage /> },
  { path: '/representative-types/:id', element: <RepresentativeTypeDetailPage /> },
  { path: '/rulecategories/new', element: <RuleCategoryDetailPage /> },
  { path: '/rulecategories/:id', element: <RuleCategoryDetailPage /> },
  { path: '/customer-additional-fields/new', element: <CustomerAdditionalFieldDetailPage /> },
  { path: '/customer-additional-fields/:id', element: <CustomerAdditionalFieldDetailPage /> },
  { path: '/product-additional-fields/new', element: <ProductAdditionalFieldDetailPage /> },
  { path: '/product-additional-fields/:id', element: <ProductAdditionalFieldDetailPage /> },
  { path: '/announcements/new', element: <AnnouncementDetailPage /> },
  { path: '/announcements/:id', element: <AnnouncementDetailPage /> },
  { path: '/document-series/new', element: <DocumentSeriesDetailPage /> },
  { path: '/document-series/:id', element: <DocumentSeriesDetailPage /> },
  { path: '/warehouses/new', element: <WarehouseDetailPage /> },
  { path: '/warehouses/:id', element: <WarehouseDetailPage /> },
  { path: '/coolers/new', element: <CoolerDetailPage /> },
  { path: '/coolers/:id', element: <CoolerDetailPage /> },
  // Demirbaş Takibi — envanter + sayım tanımı detayları (/new :id'den ÖNCE)
  { path: '/assets/new', element: <AssetDetailPage /> },
  { path: '/assets/:id', element: <AssetDetailPage /> },
  { path: '/asset-count-orders/new', element: <AssetCountOrderDetailPage /> },
  { path: '/asset-count-orders/:id', element: <AssetCountOrderDetailPage /> },
  { path: '/asset-models/new', element: <AssetModelDetailPage /> },
  { path: '/asset-models/:id', element: <AssetModelDetailPage /> },
  { path: '/asset-attribute-defs/new', element: <AssetAttributeDefDetailPage /> },
  { path: '/asset-attribute-defs/:id', element: <AssetAttributeDefDetailPage /> },
  // Popup→DetailPage migrasyonu (Dalga 2)
  { path: '/role-management/new', element: <RoleDetailPage /> },
  { path: '/role-management/:id', element: <RoleDetailPage /> },
  { path: '/user-management/new', element: <UserDetailPage /> },
  { path: '/user-management/:id', element: <UserDetailPage /> },
  { path: '/customer-notes/new', element: <CustomerNoteDetailPage /> },
  { path: '/customer-notes/:id', element: <CustomerNoteDetailPage /> },
  { path: '/customer-tasks/new', element: <CustomerTaskDetailPage /> },
  { path: '/customer-tasks/:id', element: <CustomerTaskDetailPage /> },
  { path: '/cooler-faults/new', element: <CoolerFaultDetailPage /> },
  { path: '/cooler-faults/:id', element: <CoolerFaultDetailPage /> },
  { path: '/trainings/new', element: <TrainingDetailPage /> },
  { path: '/trainings/:id', element: <TrainingDetailPage /> },
  { path: '/dbs/new', element: <DbsDefinitionDetailPage /> },
  { path: '/dbs/:id', element: <DbsDefinitionDetailPage /> },
  { path: '/shipment-vehicles/new', element: <ShipmentVehicleDetailPage /> },
  { path: '/shipment-vehicles/:id', element: <ShipmentVehicleDetailPage /> },
  { path: '/distributors/new', element: <DistributorDetailPage /> },
  { path: '/distributors/:id', element: <DistributorDetailPage /> },
  // Popup→DetailPage migrasyonu (Dalga 3)
  { path: '/vendors/new', element: <VendorDetailPage /> },
  { path: '/vendors/:id', element: <VendorDetailPage /> },
  { path: '/representatives/new', element: <RepresentativeDetailPage /> },
  { path: '/representatives/:id', element: <RepresentativeDetailPage /> },
  { path: '/prices/new', element: <PriceDetailPage /> },
  { path: '/prices/:id', element: <PriceDetailPage /> },
  { path: '/rules/new', element: <RuleDetailPage /> },
  { path: '/rules/:id', element: <RuleDetailPage /> },
  { path: '/surveys/new', element: <SurveyDetailPage /> },
  { path: '/surveys/:id', element: <SurveyDetailPage /> },
  { path: '/agreements/new', element: <AgreementDetailPage /> },
  { path: '/agreements/:id', element: <AgreementDetailPage /> },
  { path: '/product-restrictions/new', element: <ProductRestrictionDetailPage /> },
  { path: '/product-restrictions/:id', element: <ProductRestrictionDetailPage /> },
  { path: '/customer-dynamic-groups/new', element: <CustomerDynamicGroupDetailPage /> },
  { path: '/customer-dynamic-groups/:id', element: <CustomerDynamicGroupDetailPage /> },
  // Popup→DetailPage migrasyonu (Dalga 4)
  { path: '/product-dynamic-groups/new', element: <ProductDynamicGroupDetailPage /> },
  { path: '/product-dynamic-groups/:id', element: <ProductDynamicGroupDetailPage /> },
  { path: '/delivery-notes/new', element: <DeliveryNoteDetailPage /> },
  { path: '/delivery-notes/:id', element: <DeliveryNoteDetailPage /> },
  { path: '/vehicle-loads/:id', element: <VehicleLoadDetailPage /> },
  { path: '/etl-pipelines/new', element: <EtlPipelineDetailPage /> },
  { path: '/etl-pipelines/:id', element: <EtlPipelineDetailPage /> },
  { path: '/payment/new', element: <PaymentDetailPage /> },
  { path: '/payment/:id', element: <PaymentDetailPage /> },
  // BelgeDizayni oluşturma (designer /belge-dizayni/:id'de kalır)
  { path: '/belge-dizayni/new', element: <BelgeDizayniCreatePage /> },
  // NamedDefinition kümesi — ortak NamedDefinitionDetailPage, wrapper config'i inline props
  { path: '/customer-groups/new', element: <NamedDefinitionDetailPage apiBase="/api/customergroups" listRoute="/customer-groups" title="Müşteri Grubu Yönetimi" codeLabel="Grup Kodu" descriptionLabel="Açıklama" /> },
  { path: '/customer-groups/:id', element: <NamedDefinitionDetailPage apiBase="/api/customergroups" listRoute="/customer-groups" title="Müşteri Grubu Yönetimi" codeLabel="Grup Kodu" descriptionLabel="Açıklama" historyEntity="CustomerGroup" /> },
  // Satamama Nedenleri (Ticari Pazarlama) — standalone liste + ortak NamedDefinitionDetailPage
  { path: '/non-sale-reasons', element: <NonSaleReasonsPage /> },
  { path: '/non-sale-reasons/new', element: <NamedDefinitionDetailPage apiBase="/api/nonsalereasons" listRoute="/non-sale-reasons" title="Satamama Nedenleri" codeLabel="Kod" descriptionLabel="Açıklama" entityLabel="Satamama Nedeni" /> },
  { path: '/non-sale-reasons/:id', element: <NamedDefinitionDetailPage apiBase="/api/nonsalereasons" listRoute="/non-sale-reasons" title="Satamama Nedenleri" codeLabel="Kod" descriptionLabel="Açıklama" entityLabel="Satamama Nedeni" /> },
  { path: '/customer-sub-groups/new', element: <NamedDefinitionDetailPage apiBase="/api/customersubgroups" listRoute="/customer-sub-groups" title="Müşteri Ek Grubu Yönetimi" codeLabel="Ek Grup Kodu" descriptionLabel="Açıklama" /> },
  { path: '/customer-sub-groups/:id', element: <NamedDefinitionDetailPage apiBase="/api/customersubgroups" listRoute="/customer-sub-groups" title="Müşteri Ek Grubu Yönetimi" codeLabel="Ek Grup Kodu" descriptionLabel="Açıklama" historyEntity="CustomerSubGroup" /> },
  { path: '/product-groups/new', element: <NamedDefinitionDetailPage apiBase="/api/productgroups" listRoute="/product-groups" title="Ürün Grubu" codeLabel="Grup Kodu" descriptionLabel="Açıklama" entityLabel="ürün grubu" /> },
  { path: '/product-groups/:id', element: <NamedDefinitionDetailPage apiBase="/api/productgroups" listRoute="/product-groups" title="Ürün Grubu" codeLabel="Grup Kodu" descriptionLabel="Açıklama" entityLabel="ürün grubu" historyEntity="ProductGroup" /> },
  { path: '/product-sub-groups/new', element: <NamedDefinitionDetailPage apiBase="/api/productsubgroups" listRoute="/product-sub-groups" title="Alt Grup" codeLabel="Alt Grup Kodu" descriptionLabel="Açıklama" entityLabel="alt grup" /> },
  { path: '/product-sub-groups/:id', element: <NamedDefinitionDetailPage apiBase="/api/productsubgroups" listRoute="/product-sub-groups" title="Alt Grup" codeLabel="Alt Grup Kodu" descriptionLabel="Açıklama" entityLabel="alt grup" historyEntity="ProductSubGroup" /> },
  { path: '/vendor-groups/new', element: <NamedDefinitionDetailPage apiBase="/api/vendorgroups" listRoute="/vendor-groups" title="Distribütör Grubu Yönetimi" codeLabel="Grup Kodu" descriptionLabel="Açıklama" entityLabel="distribütör grubu" /> },
  { path: '/vendor-groups/:id', element: <NamedDefinitionDetailPage apiBase="/api/vendorgroups" listRoute="/vendor-groups" title="Distribütör Grubu Yönetimi" codeLabel="Grup Kodu" descriptionLabel="Açıklama" entityLabel="distribütör grubu" historyEntity="VendorGroup" /> },
  { path: '/vendor-sub-groups/new', element: <NamedDefinitionDetailPage apiBase="/api/vendorsubgroups" listRoute="/vendor-sub-groups" title="Distribütör Ek Grubu Yönetimi" codeLabel="Ek Grup Kodu" descriptionLabel="Açıklama" /> },
  { path: '/vendor-sub-groups/:id', element: <NamedDefinitionDetailPage apiBase="/api/vendorsubgroups" listRoute="/vendor-sub-groups" title="Distribütör Ek Grubu Yönetimi" codeLabel="Ek Grup Kodu" descriptionLabel="Açıklama" historyEntity="VendorSubGroup" /> },
  // #829 withVendor: Üretici kartında "Distribütör" alanı (zorunlu değil; boş = tüm distribütörler).
  // Alan OPT-IN — NamedDefinitionDetailPage'i paylaşan diğer tanım ekranları etkilenmez.
  { path: '/producers/new', element: <NamedDefinitionDetailPage apiBase="/api/producers" listRoute="/producers" title="Üretici" codeLabel="Üretici Kodu" descField="name" descriptionLabel="Üretici Adı" descRequired entityLabel="üretici" withVendor /> },
  { path: '/producers/:id', element: <NamedDefinitionDetailPage apiBase="/api/producers" listRoute="/producers" title="Üretici" codeLabel="Üretici Kodu" descField="name" descriptionLabel="Üretici Adı" descRequired entityLabel="üretici" historyEntity="Producer" withVendor /> },
  { path: '/representative-groups/new', element: <NamedDefinitionDetailPage apiBase="/api/representativegroups" listRoute="/representative-groups" title="Temsilci Grubu" codeLabel="Grup Kodu" descriptionLabel="Açıklama" descRequired entityLabel="temsilci grubu" /> },
  { path: '/representative-groups/:id', element: <NamedDefinitionDetailPage apiBase="/api/representativegroups" listRoute="/representative-groups" title="Temsilci Grubu" codeLabel="Grup Kodu" descriptionLabel="Açıklama" descRequired entityLabel="temsilci grubu" historyEntity="RepresentativeGroup" /> },
  { path: '/sales-managers/new', element: <NamedDefinitionDetailPage apiBase="/api/salesmanagers" listRoute="/sales-managers" title="Satış Müdürü" codeLabel="Kod" descriptionLabel="Açıklama" descRequired entityLabel="satış müdürü" /> },
  { path: '/sales-managers/:id', element: <NamedDefinitionDetailPage apiBase="/api/salesmanagers" listRoute="/sales-managers" title="Satış Müdürü" codeLabel="Kod" descriptionLabel="Açıklama" descRequired entityLabel="satış müdürü" historyEntity="SalesManager" /> },
  { path: '/payment-types/new', element: <NamedDefinitionDetailPage apiBase="/api/paymenttypes" listRoute="/payment-types" title="Ödeme Tipi Yönetimi" codeLabel="Kod" descriptionLabel="Ödeme Tipi" /> },
  { path: '/payment-types/:id', element: <NamedDefinitionDetailPage apiBase="/api/paymenttypes" listRoute="/payment-types" title="Ödeme Tipi Yönetimi" codeLabel="Kod" descriptionLabel="Ödeme Tipi" historyEntity="PaymentType" /> },
  // Popup→DetailPage migrasyonu (Final)
  { path: '/workflows/new', element: <WorkflowDetailPage /> },
  { path: '/workflows/:id', element: <WorkflowDetailPage /> },
  { path: '/risk-categories/new', element: <RiskCategoryDetailPage /> },
  { path: '/risk-categories/:id', element: <RiskCategoryDetailPage /> },
  { path: '/risk-masters/new', element: <RiskMasterDetailPage /> },
  { path: '/risk-masters/:id', element: <RiskMasterDetailPage /> },
  { path: '/customers', element: <CustomersPage /> },
  { path: '/customers/new', element: <CustomerEditPage /> },
  { path: '/customers/:id/edit', element: <CustomerEditPage /> },
  { path: '/customers/:id/view', element: <CustomerEditPage /> },
  { path: '/customers/:id', element: <CustomerDetailPage /> },
  // Grup/Alt Grup listeleri CustomersPage shell'i içinde (sekmeli) açılır — kayıt sonrası
  // listeye dönüşte üstteki sekmeler kaybolmasın diye (NamedDefinitionPage tek başına sekmesizdi).
  { path: '/customer-groups', element: <CustomersPage definition="groups" /> },
  { path: '/customer-sub-groups', element: <CustomersPage definition="subGroups" /> },
  { path: '/customer-additional-fields', element: <CustomerAdditionalFieldsPage /> },
  { path: '/customer-additional-fields-legacy', element: <CustomerAdditionalFieldsPageLegacy /> },
  { path: '/customer-dynamic-groups', element: <CustomerDynamicGroupsPage /> },
  { path: '/customer-dynamic-groups-legacy', element: <CustomerDynamicGroupsPageLegacy /> },
  { path: '/vendors', element: <VendorsPage /> },
  { path: '/vendors-legacy', element: <VendorsPageLegacy /> },
  // #710: Grup/Alt Grup listeleri de VendorsPage üzerinden (sekmeli) açılır. Detay kaydından
  // listRoute'a (/vendor-groups) dönüldüğünde üst sekmeler kaybolmaz; sekme URL'den türetilir.
  { path: '/vendor-groups', element: <VendorsPage /> },
  { path: '/vendor-sub-groups', element: <VendorsPage /> },
  { path: '/warehouses', element: <WarehousesPage /> },
  { path: '/warehouses-legacy', element: <WarehousesPageLegacy /> },
  { path: '/shipment-vehicles', element: <ShipmentVehiclesPage /> },
  { path: '/distributors', element: <DistributorsPage /> },
  { path: '/soap-services', element: <SoapServicesPage /> },
  { path: '/soap-services/new', element: <SoapServiceDetailPage /> },
  { path: '/soap-services/:id', element: <SoapServiceDetailPage /> },
  { path: '/stocks', element: <StockPage /> },
  { path: '/stocks-legacy', element: <StockPageLegacy /> },
  { path: '/stock-entry', element: <StockDocumentsListPage variant="entry" /> },
  { path: '/stock-exit', element: <StockDocumentsListPage variant="exit" /> },
  { path: '/stock-transfer', element: <StockDocumentsListPage variant="transfer" /> },
  // Menü 9537 / 9538 — araçlar arası transfer izleme ve TRANSIT'te asılı fark çözümleme.
  { path: '/vehicle-transfers', element: <StockTransfersPage /> },
  { path: '/vehicle-transfers/:id', element: <StockTransferDetailPage /> },
  { path: '/transit-balances', element: <StockTransfersPage focus="transit" /> },
  { path: '/warehouse-stock-reset', element: <WarehouseStockResetListPage /> },
  { path: '/warehouse-stock-reset/new', element: <WarehouseStockResetDetailPage /> },
  { path: '/warehouse-stock-reset/:documentId', element: <WarehouseStockResetDetailPage /> },
  { path: '/product-segmentation-tree', element: <ProductSegmentationTreeListPage /> },
  { path: '/product-segmentation-tree/new', element: <ProductSegmentationTreePage /> },
  { path: '/product-segmentation-tree/:id', element: <ProductSegmentationTreePage /> },
  { path: '/representative-types', element: <RepresentativeTypesPage /> },
  { path: '/representative-types-legacy', element: <RepresentativeTypesPageLegacy /> },
  { path: '/sales-managers', element: <SalesManagersPage /> },
  { path: '/representatives', element: <RepresentativesPage /> },
  { path: '/representatives-legacy', element: <RepresentativesPageLegacy /> },
  { path: '/representative-groups', element: <RepresentativeGroupsPage /> },
  { path: '/order-headers', element: <OrderHeadersPage /> },
  { path: '/orders/new', element: <OrderDetailPage /> },
  { path: '/orders/:id', element: <OrderDetailPage /> },
  { path: '/purchase-orders', element: <OrderHeadersPage variant="purchase" /> },
  // #833 — İade siparişleri türe göre üç ayrı menü/ekran (menü 9562/9563/9564). Eski birleşik
  // /return-orders rotası menüden kaldırıldı ama eski bağlantılar kırılmasın diye ayakta kalır.
  { path: '/return-orders', element: <OrderHeadersPage variant="return" /> },
  { path: '/return-orders-good', element: <OrderHeadersPage variant="returnGood" /> },
  { path: '/return-orders-damaged', element: <OrderHeadersPage variant="returnDamaged" /> },
  { path: '/return-orders-vendor', element: <OrderHeadersPage variant="returnVendor" /> },
  { path: '/invoices', element: <InvoicesPage /> },
  // Fatura detayı V2 tasarıma geçti — SEKİZ varyantın hepsinde (satış · alış · iade ×4 ·
  // hizmet ×2). Prototip menüsü (9950) ve /invoices-v2 rotası kaldırıldı. Eski ekran
  // `components/InvoiceDetailPage.js` olarak DURUYOR (import edilmiyor) — geri dönmek
  // gerekirse import edip aşağıdaki detay satırlarını ona çevirmek yeterli.
  { path: '/invoices/new', element: <InvoiceDetailV2Page /> },
  { path: '/invoices/:id', element: <InvoiceDetailV2Page /> },
  { path: '/purchase-invoices', element: <InvoicesPage variant="purchase" /> },
  // Varyanta özel yeni/detay route'ları — doğru menü vurgusu için (Alış/İade/Hizmet).
  { path: '/purchase-invoices/new', element: <InvoiceDetailV2Page /> },
  { path: '/purchase-invoices/:id', element: <InvoiceDetailV2Page /> },
  // #835 — İade faturaları türe göre üç ayrı menü/ekran (menü 9568/9569/9570). Eski birleşik
  // /return-invoices rotası menüden kaldırıldı ama eski bağlantılar kırılmasın diye ayakta kalır.
  { path: '/return-invoices', element: <InvoicesPage variant="return" /> },
  { path: '/return-invoices/new', element: <InvoiceDetailV2Page /> },
  { path: '/return-invoices/:id', element: <InvoiceDetailV2Page /> },
  { path: '/return-invoices-good', element: <InvoicesPage variant="returnGood" /> },
  { path: '/return-invoices-good/new', element: <InvoiceDetailV2Page /> },
  { path: '/return-invoices-good/:id', element: <InvoiceDetailV2Page /> },
  { path: '/return-invoices-damaged', element: <InvoicesPage variant="returnDamaged" /> },
  { path: '/return-invoices-damaged/new', element: <InvoiceDetailV2Page /> },
  { path: '/return-invoices-damaged/:id', element: <InvoiceDetailV2Page /> },
  { path: '/return-invoices-vendor', element: <InvoicesPage variant="returnVendor" /> },
  { path: '/return-invoices-vendor/new', element: <InvoiceDetailV2Page /> },
  { path: '/return-invoices-vendor/:id', element: <InvoiceDetailV2Page /> },
  // Menü 9545 / 9546 / 9547 — Faz 4 satıcıya iade (saha belgesi = ReturnHeader).
  // /return-invoices MUHASEBE görünümüdür (Invoice) ve yerinde durur; ikisi aynı Id'de buluşur.
  { path: '/vendor-returns', element: <VendorReturnsPage /> },
  { path: '/vendor-returns/new', element: <VendorReturnCreatePage /> },
  { path: '/vendor-returns/:id', element: <VendorReturnDetailPage /> },
  { path: '/gib-monitor', element: <GibMonitorPage /> },
  { path: '/reports/returnable-quantities', element: <ReturnableQuantitiesReportPage /> },
  // Menü 9550 — Faz 6 E-Belge Kontrol (Belge Merkezi altında). e-Fatura + e-Arşiv + e-İrsaliye
  // hattının TAMAMINI üç bağımsız eksende izler; /gib-monitor (9546, yalnız satıcıya iade) AYRI kalır.
  { path: '/e-belge-kontrol', element: <EDocumentControlPage /> },
  // Menü 9548 / 9549 — Faz 5 depozito iadesi. Belgede TUTAR YOKTUR (emanetin geri verilmesi);
  // karşılığı para değil, depozito bakiyesinin azalmasıdır. Detay SALT-OKUNUR (saha belgesi).
  { path: '/deposit-returns', element: <DepositReturnsPage /> },
  { path: '/deposit-returns/:id', element: <DepositReturnDetailPage /> },
  { path: '/deposit-reconciliation', element: <DepositReconciliationPage /> },
  // Menü 9551 — Nama Sevk Belgeleri. Belge normalde SAP/telsel ingest'inden ya da mobilden doğar;
  // /new masabaşı girişidir (kaynak yalnız SAP/TELSEL, satıcıyı SUNUCU belirler). Detay ekranı
  // belgeyi yeniden yazmaz: teslimatı kaydeder (?edit=1) ya da belgeyi iptal eder.
  { path: '/nama-documents', element: <NamaDocumentsPage /> },
  { path: '/nama-documents/new', element: <NamaDocumentCreatePage /> },
  { path: '/nama-documents/:id', element: <NamaDocumentDetailPage /> },
  { path: '/waybills', element: <WaybillsPage /> },
  { path: '/waybills/new', element: <WaybillDetailPage /> },
  { path: '/waybills/:id', element: <WaybillDetailPage /> },
  { path: '/purchase-waybills', element: <WaybillsPage variant="purchase" /> },
  { path: '/purchase-waybills/new', element: <WaybillDetailPage /> },
  { path: '/purchase-waybills/:id', element: <WaybillDetailPage /> },
  // #834 — İade irsaliyeleri türe göre üç ayrı menü/ekran (menü 9565/9566/9567). Eski birleşik
  // /return-waybills rotası menüden kaldırıldı ama eski bağlantılar kırılmasın diye ayakta kalır.
  { path: '/return-waybills', element: <WaybillsPage variant="return" /> },
  { path: '/return-waybills/new', element: <WaybillDetailPage /> },
  { path: '/return-waybills/:id', element: <WaybillDetailPage /> },
  { path: '/return-waybills-good', element: <WaybillsPage variant="returnGood" /> },
  { path: '/return-waybills-good/new', element: <WaybillDetailPage /> },
  { path: '/return-waybills-good/:id', element: <WaybillDetailPage /> },
  { path: '/return-waybills-damaged', element: <WaybillsPage variant="returnDamaged" /> },
  { path: '/return-waybills-damaged/new', element: <WaybillDetailPage /> },
  { path: '/return-waybills-damaged/:id', element: <WaybillDetailPage /> },
  { path: '/return-waybills-vendor', element: <WaybillsPage variant="returnVendor" /> },
  { path: '/return-waybills-vendor/new', element: <WaybillDetailPage /> },
  { path: '/return-waybills-vendor/:id', element: <WaybillDetailPage /> },
  // #829 Konsinye SATIŞ İrsaliyesi (Demirbaş'tan Belge Merkezi › Konsinye altına taşındı, menü 9138).
  { path: '/consignment-waybills', element: <WaybillsPage variant="consignment" /> },
  { path: '/consignment-waybills/new', element: <WaybillDetailPage /> },
  { path: '/consignment-waybills/:id', element: <WaybillDetailPage /> },
  // #830 Konsinye ALIŞ İrsaliyesi (Type 8) — menü 9572.
  { path: '/consignment-purchase-waybills', element: <WaybillsPage variant="consignmentPurchase" /> },
  { path: '/consignment-purchase-waybills/new', element: <WaybillDetailPage /> },
  { path: '/consignment-purchase-waybills/:id', element: <WaybillDetailPage /> },
  { path: '/service-invoices-given', element: <InvoicesPage variant="serviceGiven" /> },
  { path: '/service-invoices-given/new', element: <InvoiceDetailV2Page /> },
  { path: '/service-invoices-given/:id', element: <InvoiceDetailV2Page /> },
  { path: '/service-invoices-received', element: <InvoicesPage variant="serviceReceived" /> },
  { path: '/service-invoices-received/new', element: <InvoiceDetailV2Page /> },
  { path: '/service-invoices-received/:id', element: <InvoiceDetailV2Page /> },
  { path: '/belge-dizayni', element: <BelgeDizayniPage /> },
  { path: '/belge-dizayni/:id', element: <BelgeDizayniDesignerPage /> },
  { path: '/document-series', element: <DocumentSeriesPage /> },
  { path: '/link-risk-tracking', element: <LinkRiskTrackingPage /> },
  { path: '/account-statement', element: <AccountStatementPage /> },
  { path: '/approval-requests', element: <ApprovalRequestsPage /> },
  { path: '/b2b-returns', element: <B2bReturnsPage /> },
  { path: '/visits', element: <VisitsPage /> },
  { path: '/vehicle-loads', element: <VehicleLoadsPage /> },
  { path: '/vehicle-counts', element: <VehicleCountsPage /> },
  { path: '/delivery-notes', element: <DeliveryNotesPage /> },
  { path: '/trainings', element: <TrainingsPage /> },
  { path: '/campaigns', element: <CampaignsPage /> },
  { path: '/campaigns/new', element: <CampaignDetailPage /> },
  { path: '/campaigns/:id', element: <CampaignDetailPage /> },
  // Kampanya Yetkileri (menü 9120) — c360 liste + DetailShell detay standardı.
  // Satır = yetki HEDEFİ (tip+id bileşik anahtar); detay hedefin 13 detayını full-replace yazar.
  { path: '/campaign-authorizations', element: <CampaignAuthorizationsPage /> },
  { path: '/campaign-authorizations/new', element: <CampaignAuthorizationDetailPage /> },
  { path: '/campaign-authorizations/:targetType/:targetId', element: <CampaignAuthorizationDetailPage /> },
  // Dönüşüm öncesi tek-sayfa hâli (karşılaştırma/geri dönüş için).
  { path: '/campaign-authorizations-legacy', element: <CampaignAuthorizationsPageLegacy /> },
  // Zamanlanmış Görevler (menü 9608) — c360 liste + DetailShell detay.
  // Detay ekranının kriter formu, görev tipinin ŞEMASINDAN üretilir (tipe özel React kodu yoktur).
  { path: '/scheduled-tasks', element: <ScheduledTasksPage /> },
  { path: '/scheduled-tasks/new', element: <ScheduledTaskDetailPage /> },
  { path: '/scheduled-tasks/:id', element: <ScheduledTaskDetailPage /> },

  // Belge Merkezi › Otomasyon › Belge Türetme Tanımları (menü 9561)
  { path: '/document-derivations', element: <DocumentDerivationsPage /> },
  { path: '/document-derivations/new', element: <DocumentDerivationDetailPage /> },
  { path: '/document-derivations/:id', element: <DocumentDerivationDetailPage /> },
  { path: '/targets', element: <TargetsPage /> },
  { path: '/targets/new', element: <TargetWizardPage /> },
  { path: '/targets/:id', element: <TargetWizardPage /> },
  { path: '/leaderboard', element: <LeaderboardPage /> },
  { path: '/gamification/badges', element: <GamificationBadgesPage /> },
  { path: '/agreements', element: <AgreementsPage /> },
  { path: '/surveys', element: <SurveysPage /> },
  { path: '/coolers', element: <CoolersPage /> },
  { path: '/cooler-faults', element: <CoolerFaultsPage /> },
  // Demirbaş Takibi — liste ekranları
  { path: '/assets', element: <AssetsPage /> },
  { path: '/asset-counts', element: <AssetCountsPage /> },
  { path: '/asset-count-orders', element: <AssetCountOrdersPage /> },
  { path: '/asset-models', element: <AssetModelsPage /> },
  { path: '/asset-attribute-defs', element: <AssetAttributeDefsPage /> },
  { path: '/asset-drafts', element: <AssetDraftsPage /> },
  { path: '/asset-import', element: <AssetImportPage /> },
  { path: '/customer-tasks', element: <CustomerTasksPage /> },
  { path: '/customer-notes', element: <CustomerNotesPage /> },
  { path: '/deposit-counts', element: <DepositCountsPage /> },
  { path: '/route-plans', element: <RoutePlansPage /> },
  { path: '/route-plans/new', element: <RoutePlanDetailPage /> },
  { path: '/route-plans/:id', element: <RoutePlanDetailPage /> },
  // #130 Sevkiyat Planlama / Sipariş Planla & Dönüştür — /new ve :id'den ÖNCE liste
  { path: '/shipment-planning', element: <ShipmentPlanningListPage /> },
  { path: '/shipment-planning/new', element: <ShipmentPlanningBoardPage /> },
  { path: '/shipment-planning/:id', element: <ShipmentPlanningBoardPage /> },
  { path: '/customer-memberships', element: <CustomerMembershipsPage /> },
  { path: '/stand-counts', element: <StandCountsPage /> },
  { path: '/reports', element: <ReportsPage /> },
  { path: '/reports/sales-detail', element: <SalesDetailReportPage /> },
  { path: '/reports/collection-detail', element: <CollectionDetailReportPage /> },
  // Sabit Rapor 5020 — Müşteri Listesi (kriter ekranı + yeni sekmede tam ekran liste)
  { path: '/reports/template-customer', element: <CustomerReportCriteriaPage /> },
  { path: '/reports/customer-list', element: <CustomerReportListPage /> },
  // Sabit Rapor 5817 — Ziyaret Analizi (kriter ekranı + ayrı pencerede rapor)
  { path: '/reports/field-visits', element: <FieldVisitsPage /> },
  { path: '/reports/field-visits/:id', element: <FieldVisitDetailPage /> },
  // Ziyaret Takip (menü 9121, Kokpit grubu) + hareket tipi sözlüğü (9122, Sistem Yönetimi)
  { path: '/visit-tracking', element: <VisitTrackingPage /> },
  { path: '/visit-activity-types', element: <VisitActivityTypesPage /> },
  { path: '/visit-activity-types/new', element: <VisitActivityTypeDetailPage /> },
  { path: '/visit-activity-types/:id', element: <VisitActivityTypeDetailPage /> },

  // #44 Ekip mesajlaşması — yasaklı kelime tanımları (menü 9621)
  { path: '/team-chat-banned-words', element: <TeamChatBannedWordsPage /> },
  { path: '/team-chat-banned-words/new', element: <TeamChatBannedWordDetailPage /> },
  { path: '/team-chat-banned-words/:id', element: <TeamChatBannedWordDetailPage /> },

  // #44 Ekip mesajlaşması — yazışma denetimi/arşivi (menü 9622). Salt okunur.
  { path: '/team-chat-archive', element: <TeamChatArchivePage /> },
  { path: '/team-chat-archive/:id', element: <TeamChatArchiveDetailPage /> },
  // #45 Destek Talepleri (9620) — "new" rotası YOK: talep kullanıcı tarafından açılır.
  { path: '/support-tickets', element: <SupportTicketsPage /> },
  { path: '/support-tickets/:id', element: <SupportTicketDetailPage /> },
  { path: '/reports/visit-analysis-criteria', element: <VisitAnalysisCriteriaPage /> },
  { path: '/reports/visit-analysis', element: <VisitAnalysisListPage /> },
  // Sabit Rapor 5550 — ST Rut Tanım Listesi (kriter ekranı + ayrı pencerede rapor)
  { path: '/reports/st-route-plans', element: <RouteDefinitionCriteriaPage /> },
  { path: '/reports/st-route-plans-list', element: <RouteDefinitionListPage /> },
  // Sabit Rapor 292166 — Rut Tanım Listesi Raporu (zengin kırılım: dist/temsilci/müşteri)
  { path: '/reports/route-plans', element: <RoutePlanDetailCriteriaPage /> },
  { path: '/reports/route-plans-list', element: <RoutePlanDetailListPage /> },
  // Sabit Rapor 5160 — Demirbaş Son Durum (Asset master + durum dağılımı)
  { path: '/reports/asset-status', element: <AssetStatusCriteriaPage /> },
  { path: '/reports/asset-status-list', element: <AssetStatusListPage /> },
  // Sabit Rapor 5280 — Stok Ekstresi (Detay) (StockMovement ledger + kümülatif bakiye)
  { path: '/reports/stock-ledger', element: <StockLedgerCriteriaPage /> },
  { path: '/reports/stock-ledger-list', element: <StockLedgerListPage /> },
  // Sabit Rapor 5380 — Ziyaret Detay Raporu (temsilci bazında ziyaret adımları, Rut İçi/Dışı pivot)
  { path: '/reports/visit-detail', element: <VisitDetailCriteriaPage /> },
  { path: '/reports/visit-detail-list', element: <VisitDetailListPage /> },
  // Sabit Rapor 5330 — Güncel Stok Raporu (vw_StockBalance + ürün/fiyat)
  { path: '/reports/current-stock', element: <CurrentStockCriteriaPage /> },
  { path: '/reports/current-stock-list', element: <CurrentStockListPage /> },
  // Sabit Rapor — Ürün Listesi (Tanımlamalar): Product master kartları
  { path: '/reports/product-list', element: <ProductListCriteriaPage /> },
  { path: '/reports/product-list-list', element: <ProductListListPage /> },
  // Sabit Rapor — Dağıtım Kanalı Listesi (Tanımlamalar): Vendor tanım kartları + bağlı sayılar
  { path: '/reports/dist-channels', element: <DistChannelListCriteriaPage /> },
  { path: '/reports/dist-channel-list', element: <DistChannelListListPage /> },
  // Sabit Rapor — Araç Tanım Listesi (Tanımlamalar): ShipmentVehicle tanım kartları
  { path: '/reports/vehicle-list', element: <VehicleListCriteriaPage /> },
  { path: '/reports/vehicle-list-list', element: <VehicleListListPage /> },
  // Sabit Rapor — Dağıtıcı Listesi (Tanımlamalar): Distributor tanım kartları + araç sayısı
  { path: '/reports/distributor-list', element: <DistributorListCriteriaPage /> },
  { path: '/reports/distributor-list-list', element: <DistributorListListPage /> },
  // Sabit Rapor — Depo Tanım Listesi (Tanımlamalar): Warehouse tanım kartları + araç sayısı
  { path: '/reports/warehouse-list', element: <WarehouseListCriteriaPage /> },
  { path: '/reports/warehouse-list-list', element: <WarehouseListListPage /> },
  // Sabit Rapor — Satış Temsilcisi Listesi (Tanımlamalar): Representative tanım kartları
  { path: '/reports/representative-list', element: <RepresentativeListCriteriaPage /> },
  { path: '/reports/representative-list-list', element: <RepresentativeListListPage /> },
  // Sabit Rapor — Fiyat Listesi (Tanımlamalar): tarih aralıklı Price kayıtları
  { path: '/reports/price-list', element: <PriceListCriteriaPage /> },
  { path: '/reports/price-list-list', element: <PriceListListPage /> },
  // Sabit Rapor — Kampanya Listesi (Tanımlamalar): Campaign tanım kartları
  { path: '/reports/campaign-list', element: <CampaignListCriteriaPage /> },
  { path: '/reports/campaign-list-list', element: <CampaignListListPage /> },
  // Sabit Rapor — Sipariş Listesi (Belge Kayıtları): OrderHeader belgeleri
  { path: '/reports/order-list', element: <OrderListCriteriaPage /> },
  { path: '/reports/order-list-list', element: <OrderListListPage /> },
  // Sabit Rapor — İrsaliye Listesi (Belge Kayıtları): tüm Waybill türleri
  { path: '/reports/waybill-list', element: <WaybillListCriteriaPage /> },
  { path: '/reports/waybill-list-list', element: <WaybillListListPage /> },
  // Sabit Rapor — Fatura Listesi (Belge Kayıtları): tüm Invoice türleri + kapanış tutarları
  { path: '/reports/invoice-list', element: <InvoiceListCriteriaPage /> },
  { path: '/reports/invoice-list-list', element: <InvoiceListListPage /> },
  // Sabit Rapor — Stok Giriş / Çıkış / Transfer (Belge Kayıtları): tek bileşen, üç variant
  // (StockDocument.DocumentType 1/2/3). Mevcut StockDocumentsListPage ile aynı desen.
  { path: '/reports/stock-entry', element: <StockDocumentCriteriaPage variant="entry" /> },
  { path: '/reports/stock-entry-list', element: <StockDocumentListPage variant="entry" /> },
  { path: '/reports/stock-exit', element: <StockDocumentCriteriaPage variant="exit" /> },
  { path: '/reports/stock-exit-list', element: <StockDocumentListPage variant="exit" /> },
  { path: '/reports/stock-transfer', element: <StockDocumentCriteriaPage variant="transfer" /> },
  { path: '/reports/stock-transfer-list', element: <StockDocumentListPage variant="transfer" /> },
  // Sabit Rapor — Finans (Tahsilat ve Ödeme) grubunun 7 raporu: tek bileşen, FinanceMethod variant'ı
  { path: '/reports/finance-cash', element: <FinanceCriteriaPage variant="cash" /> },
  { path: '/reports/finance-cash-list', element: <FinanceListPage variant="cash" /> },
  { path: '/reports/finance-transfer', element: <FinanceCriteriaPage variant="transfer" /> },
  { path: '/reports/finance-transfer-list', element: <FinanceListPage variant="transfer" /> },
  { path: '/reports/finance-card', element: <FinanceCriteriaPage variant="card" /> },
  { path: '/reports/finance-card-list', element: <FinanceListPage variant="card" /> },
  { path: '/reports/finance-cheque', element: <FinanceCriteriaPage variant="cheque" /> },
  { path: '/reports/finance-cheque-list', element: <FinanceListPage variant="cheque" /> },
  { path: '/reports/finance-note', element: <FinanceCriteriaPage variant="note" /> },
  { path: '/reports/finance-note-list', element: <FinanceListPage variant="note" /> },
  { path: '/reports/finance-dbs', element: <FinanceCriteriaPage variant="dbs" /> },
  { path: '/reports/finance-dbs-list', element: <FinanceListPage variant="dbs" /> },
  { path: '/reports/finance-manual', element: <FinanceCriteriaPage variant="manual" /> },
  { path: '/reports/finance-manual-list', element: <FinanceListPage variant="manual" /> },
  // Sabit Rapor — Stok Ekstresi Özet (Hareket Kayıtları): ürün × depo açılış/giriş/çıkış/kapanış
  { path: '/reports/stock-ledger-summary', element: <StockLedgerSummaryCriteriaPage /> },
  { path: '/reports/stock-ledger-summary-list', element: <StockLedgerSummaryListPage /> },
  // Sabit Rapor — Müşteri Hesap Ekstresi Özet (Hareket Kayıtları): cari açılış/borç/alacak/kapanış
  { path: '/reports/customer-statement-summary', element: <CustomerStatementSummaryCriteriaPage /> },
  { path: '/reports/customer-statement-summary-list', element: <CustomerStatementSummaryListPage /> },
  // Sabit Rapor — Müşteri Hesap Ekstresi Detay (Hareket Kayıtları): satır satır cari + yürüyen bakiye
  { path: '/reports/customer-statement-detail', element: <CustomerStatementDetailCriteriaPage /> },
  { path: '/reports/customer-statement-detail-list', element: <CustomerStatementDetailListPage /> },
  // Sabit Rapor — Müşteri – Ürün Hareket Analizi (Analizler): belge kalemi bazında
  { path: '/reports/customer-product', element: <CustomerProductCriteriaPage /> },
  { path: '/reports/customer-product-list', element: <CustomerProductListPage /> },
  { path: '/chief-dashboard', element: <ChiefDashboardPage /> },
  { path: '/notifications', element: <NotificationsPage /> },
  { path: '/sales-analytics', element: <SalesAnalyticsPage /> },
  { path: '/counter', element: <Counter /> },
  { path: '/fetch-data', element: <FetchData /> },
];

export default withGuard(AppRoutes);
